import { Link } from 'react-router-dom';
import { PRICING } from '../../config/pricingConfig';
import { FaqAccordion, type FaqItem } from '../FaqAccordion';

const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'What is a credit?',
    answer:
      'A credit is used each time you generate fingerings for a score. One credit is consumed per generation, regardless of the score length (within your plan limits).',
  },
  {
    question: 'What happens when I run out of credits?',
    answer:
      'If you run out of credits, you can purchase a credit pack or wait for your monthly credits to reset at your next billing cycle. You can also still generate fingerings with free-tier limits (3 systems for PDF or page images, 18 measures for MusicXML).',
  },
  {
    question: 'Do unused monthly credits roll over?',
    answer: `No, unused monthly credits do not roll over. Your monthly credit balance resets to your plan allocation (${PRICING.starter.credits} for Starter, ${PRICING.pro.credits} for Pro) at each billing cycle. However, extra credits purchased via credit packs never expire.`,
  },
  {
    question: 'What are extra credits?',
    answer: `Extra credits are purchased one-time via credit packs ($${PRICING.creditPack.price.toFixed(2)} for ${PRICING.creditPack.credits} credits) and never expire. They are consumed after your monthly credits run out.`,
  },
  {
    question: 'Can I upgrade or downgrade my plan?',
    answer:
      'Yes! Upgrades (e.g., Starter to Pro) take effect immediately and your credits are refilled. Downgrades are scheduled for the end of your current billing period so you keep your current benefits until then.',
  },
  {
    question: 'Can I switch between monthly and annual billing?',
    answer:
      'You can switch from monthly to annual billing, which takes effect at your next billing date. Switching from annual to monthly is not available — you can switch to monthly when your annual period ends.',
  },
  {
    question: 'Can I cancel my subscription?',
    answer:
      'Yes, you can cancel anytime from My Profile using Manage billing. If you have a scheduled plan change (e.g., a pending downgrade), cancel it first using the "Cancel Change" button next to the scheduled change notice, then use Manage billing to cancel your subscription. Your plan benefits continue until the end of your current billing period. Extra credits from credit packs are preserved even after cancellation.',
  },
  {
    question: 'What file formats are supported?',
    answer:
      'We support MusicXML, PDF, and page images (JPG, PNG, and WEBP). Without a credit, each project is limited to 18 measures (MusicXML) or 3 systems (PDF or images). Spending a credit — from a Starter or Pro plan, or from a credit pack — raises that to 300 measures (MusicXML) or 50 systems (PDF or images) per project.',
  },
];

export const FaqSection = () => (
  <div className="mt-8 mb-8 w-full max-w-6xl sm:mt-12">
    <FaqAccordion
      items={FAQ_ITEMS}
      maxWidthClass="max-w-6xl"
      align="left"
      variant="flat"
      heading="Frequently asked questions"
      subtitle={
        <>
          Commonly asked questions about pricing &amp; plans. Can&apos;t find
          what you&apos;re looking for?{' '}
          <Link to="/support" className="underline">
            Contact our friendly team
          </Link>
        </>
      }
    />
  </div>
);
